// Docs: https://webpack.js.org/loaders/expose-loader/
import $ from "expose-loader?exposes=$,jQuery!jquery";

import "bootstrap3-js/transition";
import "bootstrap3-js/modal";
import "bootstrap3-js/button";
import "bootstrap3-js/tab";
import "bootstrap3-js/tooltip";
import "bootstrap3-js/popover";
import "bootstrap3-js/dropdown";
import "bootstrap3-js/alert";
import "bootstrap3-js/collapse";
import "bootstrap-datepicker";
import moment from "moment";
import "moment/locale/pl";
import "moment/locale/ru";
import "moment/locale/ro";
import "moment/locale/cs";
import "moment/locale/hr";
import "moment/locale/sk";
import "moment/locale/de";
import "moment/locale/nl";
import "moment/locale/es";
import "moment-timezone";
import "select2";
import "jquery-minicolors";

var defaultSelect2Options = {
  dropdownAutoWidth: true,
  allowClear: true,
};

const app = {
  initMoment: function () {
    moment.locale("pl");
  },

  initSelect2: function () {
    // Provide a getter and setter for semtree, so that we don't need to handle select2 specifics in semtree
    const makeCustomField = (el, parser = (id) => id) => {
      const field = $(el).parents("[data-field-id]")[0];
      if (!field) {
        return;
      }
      field.setAttribute("data-custom-field-type", "select2");
      field.getCustomFieldProperties = () => ({
        value: $(el).select2("val"),
      });
      field.setCustomFieldValue = (newValue) =>
        $(el).select2("val", parser(newValue));
    };
    $("[data-select2-opts]").each(function (_, elem) {
      let select2Opts = elem.dataset["select2Opts"];
      var opts = select2Opts ? JSON.parse(select2Opts) : {};
      opts = Object.assign(defaultSelect2Options, opts);
      let vals = opts.val ? opts.val : [];
      $(elem)
        .val(vals)
        .select2(opts)
        .on("select2-selected", function () {
          this.dispatchEvent(new Event("change"));
        });
      // TODO: maybe it would make sense to convert the value on output as well
      makeCustomField(elem, (value) => (value || "").split(","));
    });

    $("select").each(function (_, elem) {
      $(elem)
        .select2({
          dropdownAutoWidth: true,
          allowClear: true,
        })
        .on("select2-selected", function () {
          // Trigger event so that value change can be noticed by JS.
          //
          // TODO: theoretically select2 should already be doing this, but for
          // some reason it doesn't. Investigate.
          this.dispatchEvent(new Event("change"));
        });
      makeCustomField(elem);
    });
  },

  initDatepicker: function () {
    $("input.datepicker").datepicker({
      autoclose: true,
      locale: "pl",
      format: "yyyy-mm-dd",
    });
  },

  initVerifyPaymentDueDate: function () {
    $("#new_invoice_form").on("submit", function (event) {
      if (
        $("#invoice_form_payment_due_date").val() <
        $("#invoice_form_invoice_date").val()
      ) {
        var confirm_message =
          "WARNING! The payment due date is earlier than the invoice date. Please, confirm that issuing this invoice has been consulted with Accounting Department.";
        if (!confirm(confirm_message)) {
          location.reload();
          return false;
        }
      }
    });
  },

  initFetchCompanyData: function () {
    $("#js-fetch-company-data").on("click", function () {
      let vatId = $("#company_vat_id").val();
      if (!vatId) return false;
      $.post(
        "/api/v1/hq/rpc",
        JSON.stringify({
          id: "",
          method: "FetchCompanyDataRequest",
          params: { vatId: vatId },
        })
      ).then(
        function (result) {
          if (result.result) {
            const r = result.result;
            var street = "";
            if (r.street) street = street + r.street;
            if (r.streetNumber) street = (street + " " + r.streetNumber).trim();
            if (r.apartmentNumber) street = street + "/" + r.apartmentNumber;
            const krsData = r.krsNumber
              ? r.krsNumber + ", " + r.krsCourt
              : null;
            $("#company_country").select2("val", "PL");
            $("#company_name").val(r.name);
            $("#company_legal_form").select2("val", r.legalForm);
            $("#company_street").val(street);
            $("#company_post_code").val(r.postcode);
            $("#company_city").val(r.city);
            $("#company_national_registry_id").val(r.regon);
            $("#company_national_registry_id_2").val(krsData);
          } else alert(JSON.stringify(result.error, null, 2));
        },
        function (error) {
          alert("Błąd wewnętrzny.");
        }
      );
      return false;
    });
  },

  initGetCompanyByVatId: function () {
    $("#company_vat_id").on("change", function () {
      let vatId = $("#company_vat_id").val().replace(/\s/g, "");
      $("#company_vat_id").val(vatId);
      $.post(
        "/api/v1/hq/rpc",
        JSON.stringify({
          id: "",
          method: "GetCompanyByVatIdRequest",
          params: { vatId },
        })
      ).then(function (result) {
        if (result.result) {
          var r = result.result;
          var message =
            "\nWpis o podanym numerze NIP już istnieje:\n\n" +
            r.name +
            ", " +
            r.street +
            ", " +
            r.postCode +
            " " +
            r.city;
          $("#company_vat_id_input")
            .addClass("has-error")
            .append(
              $("<span/>)", {
                id: "vat-id-err",
                text: message,
                class: "help-block",
              })
            );
        } else {
          $("#company_vat_id_input").removeClass("has-error");
          $("#vat-id-err").remove();
        }
      });
    });
    return false;
  },
  initGroupPromotionsForm: function () {
    var discountTypeElement = document.getElementById(
      "group_promotions_form_discount_type"
    );
    var prizeElement = document.getElementById(
      "group_promotions_form_prize_input"
    );
    var percentageElement = document.getElementById(
      "group_promotions_form_percentage_input"
    );
    function handleDiscountTypeChange() {
      if (discountTypeElement.value === "PriceDiscount") {
        prizeElement.classList.remove("hidden");
        percentageElement.classList.add("hidden");
      } else if (discountTypeElement.value === "PercentageDiscount") {
        percentageElement.classList.remove("hidden");
        prizeElement.classList.add("hidden");
      }
    }
    var addToAllElement = document.getElementById(
      "group_promotions_form_add_to_all"
    );
    var restaurantIdsElement = document.getElementById(
      "group_promotions_form_restaurant_ids_input"
    );
    function handleAddToAllChange() {
      console.log(addToAllElement.checked);
      if (addToAllElement.checked) {
        restaurantIdsElement.classList.add("hidden");
      } else {
        restaurantIdsElement.classList.remove("hidden");
      }
    }
    if (discountTypeElement) {
      handleDiscountTypeChange();
      discountTypeElement.onchange = handleDiscountTypeChange;
    }
    if (addToAllElement) {
      handleAddToAllChange();
      addToAllElement.onchange = handleAddToAllChange;
    }
  },
};

$(function () {
  app.initMoment();
  app.initSelect2();
  app.initDatepicker();
  app.initFetchCompanyData();
  app.initGetCompanyByVatId();
  app.initVerifyPaymentDueDate();
  app.initGroupPromotionsForm();
});
